import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/course/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/course/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.course.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveCourseAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_COURSE_ASYNC, vo });

            EditService.saveCourse(
                vo,
                response => {
                    dispatch(Actions.saveCourseSuccess(response));
                },
                error => {
                    dispatch(Actions.saveCourseFailure(error));
                }
            );
        };
    },

    saveCourseSuccess: data => ({
        type: ActionTypes.SAVE_COURSE_SUCCESS,
        parentType: ActionTypes.SAVE_COURSE_ASYNC,
        data
    }),

    saveCourseFailure: error => ({
        type: ActionTypes.SAVE_COURSE_FAILURE,
        parentType: ActionTypes.SAVE_COURSE_ASYNC,
        error
    }),

    createCourse: (productId) => ({
        type: ActionTypes.CREATE_COURSE,
        productId
    })
};

//
// Initial State
//
const INITIAL_STATE = {
    course: null,
    courseWithCategory:null,
    enableLearnFunction: false,
    categories: null,
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, enableLearnFunction: data.enableLearnFunction, course: data.enableLearnFunction ? null : data.course, courseWithCategory: data.enableLearnFunction ? data.courseWithCategory: null, categories: data.categories };
};

const createCourseReducer = (state, { productId }) => {
    return { ...state, course: { productId } };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_COURSE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_COURSE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_COURSE_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.CREATE_COURSE]: createCourseReducer
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
